<template>
	<v-menu bottom min-width="200px" rounded offset-y>
		<template v-slot:activator="{ on }">
			<v-btn v-on="on" text elevation="0" plain color="grey">
				{{ text }}<v-icon class="ml-2">$chevron-down</v-icon>
			</v-btn>
		</template>
		<v-card class="d-flex flex-column py-2">
			<template v-for="(filter, i) in filters">
				<post-dropdown-button
					:text="filter.text"
					v-bind:key="'filter-' + i"
					:action="filter.action"
				/>
			</template>
		</v-card>
	</v-menu>
</template>

<script>
import PostDropdownButton from "@/components/wall/post/PostDropdownButton";
import { mapActions } from "vuex";

export default {
	name: "PostCommentSort",
	components: {
		PostDropdownButton
	},
	props: {
		post: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			current: null,
			text: null,
			filters: [
				{
					value: null,
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.commentFilters.all'),
					action: () => {
						this.emitFilter(null)
					}
				},
				{
					value: 'new',
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.commentFilters.new'),
					action: () => {
						this.emitFilter('new')
					}
				},
				{
					value: 'popular',
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.commentFilters.popular'),
					action: () => {
						this.emitFilter('popular')
					}
				},
			]
		}
	},
	created() {
		this.setText()
	},
	methods: {
		...mapActions('wall', [
			'getComments'
		]),
		setText (v = null) {
			this.text = this.filters.find(f => f.value === v).text
		},
		emitFilter(sort) {
			this.setText(sort)
			let id = this.post.id
			this.getComments({ id, sort })
		}
	}
}
</script>
